import React from 'react';

const PLATFORMS = [
  { key: 'telegram', label: 'Telegram', description: 'Channels & chats via bot token' },
  { key: 'whatsapp', label: 'WhatsApp', description: 'Group broadcast via whatsapp-web' },
  { key: 'facebook', label: 'Facebook', description: 'Messenger thread' },
];

export default function PlatformToggles({ platforms, availability, onChange }) {
  const toggle = (key) => {
    onChange({ ...platforms, [key]: !platforms?.[key] });
  };

  return (
    <div className="platform-toggles">
      {PLATFORMS.map((p) => {
        const enabled = platforms?.[p.key] !== false;
        const available = availability?.[p.key];
        const disabled = available === false;
        return (
          <div
            key={p.key}
            className={`platform-row ${enabled ? 'enabled' : 'disabled'} ${disabled ? 'unavailable' : ''}`}
          >
            <div className="platform-info">
              <div className="platform-label">
                <span className={`platform-dot ${p.key}`} />
                {p.label}
                {disabled && <span className="platform-warning">not configured</span>}
              </div>
              <div className="platform-desc">{p.description}</div>
            </div>
            <label className="toggle">
              <input
                type="checkbox"
                checked={enabled}
                onChange={() => toggle(p.key)}
                disabled={disabled}
              />
              <span className="slider" />
            </label>
          </div>
        );
      })}
    </div>
  );
}
